// Lib
import React from 'react';

// Components
import { Input } from '@components/ui/input';

// Types
import type {
  OrganizationAnswers,
  OrganizationErrors,
} from '../../model/useCreateOrganization';

interface CreatorInfoStepProps {
  answers: OrganizationAnswers;
  error: OrganizationErrors;
  onChange: (name: string, value: string) => void;
  onSetError: (name: string, value: string) => void;
}

export const CreatorInfoStep: React.FC<CreatorInfoStepProps> = ({
  answers,
  error,
  onChange,
  onSetError,
}) => (
  <>
    <h1 className="mb-12 text-center text-2xl font-bold tracking-tight text-foreground">
      Create your public influencer profile
    </h1>
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4">
        <p className="text-center text-sm font-medium text-foreground">
          Display name
        </p>
        <Input
          type="text"
          name="name"
          placeholder="Display name"
          aria-invalid={Boolean(error?.name)}
          onChange={(field) => {
            if (error?.name) onSetError('name', '');
            onChange('name', field.target.value);
          }}
          value={answers?.name}
        />
        {error?.name && (
          <p className="text-xs text-marble-red-500">{error.name}</p>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <p className="text-center text-sm font-medium text-foreground">
          Contact email
        </p>
        <Input
          type="text"
          name="email"
          placeholder="tom.losangeles@yahoo.com"
          aria-invalid={Boolean(error?.email)}
          onChange={(field) => {
            if (error?.email) onSetError('email', '');
            onChange('email', field.target.value);
          }}
          value={answers?.email}
        />
        {error?.email && (
          <p className="text-xs text-marble-red-500">{error.email}</p>
        )}
      </div>
    </div>
  </>
);
